import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isRibbonVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["wc-coupon-ribbon py-1 px-2 font-size-xs rounded", _ctx.variant])
      }, _toDisplayString(_ctx.textContent), 3))
    : _createCommentVNode("", true)
}